import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import NoteService from 'services/NoteService';
import UserService from 'services/UserService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import DatePicker from 'components/common/DatePicker';

//-------------------------------------------------------------------------------------------------------------------

class EditNoteModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.noteID = opts.noteID;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true
            });
            this.load();
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    async load() {
        // Load or create note
        let note;
        if (this.noteID) {
            note = await NoteService.get(this.noteID);
        } else {
            note = {
                ...this.opts,
                userID: this.loginInfo.user.id,
                noteType: this.opts.newNoteType,
                dateTime: new Date()
            };
        }

        // Load other info
        const users = await UserService.list({
            role: 'Admin',
            forceID: note.userID
        });

        // Update UI
        this.setState({
            note,
            users,
            isLoading: false
        });
    }

    updateFields(values) {
        const note = { ...this.state.note };
        for (var field in values) {
            const value = values[field];
            if (value != note[field]) {
                note[field] = value;
            }
        }
        this.setState({ note });
    }

    async saveAndClose() {
        const { note } = this.state;
        this.setState({ isLoading: true });
        await NoteService.save(note);
        this.close();
        this.resolve();
    }

    async confirmDelete() {
        const confirm = await BootboxHelper.confirm(`Are you sure you want to delete this note?`);
        if (confirm) {
            this.delete();
        }
    }

    async delete() {
        this.setState({ isLoading: true });
        await NoteService.delete(this.state.note.id);
        this.close();
        this.resolve();
    }
    
    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="edit-note-modal">
                {this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            isLoading,
            note,
            users
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader fullPage />
                </Modal.Body>
            );
        }

        return (

            <form onSubmit={e => { e.preventDefault(); e.stopPropagation(); this.saveAndClose() }}>
                <Modal.Body>

                    <Form.Group className="mb-3">
                        <Form.Label>Date</Form.Label>
                        <DatePicker
                            className="form-control"
                            selected={note.dateTime ? new Date(note.dateTime) : null}
                            onChange={value => this.updateFields({ dateTime: value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Added by</Form.Label>
                        <select
                            className="form-control"
                            value={note.userID || ''}
                            onChange={e => this.updateFields({ userID: e.target.value })}
                        >
                            <option value="">(Select)</option>
                            {users.map(u =>
                                <option key={u.id} value={u.id}>
                                    {u.firstName} {u.lastName}
                                </option>
                            )}
                        </select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Note</Form.Label>
                        <ExpandingTextArea
                            autoFocus={!note.id}
                            className="form-control"
                            value={note.text || ''}
                            rows="4"
                            onChange={e => this.updateFields({ text: e.target.value })}
                        /> 
                    </Form.Group>

                    <Form.Group className="">
                        <Form.Label>Options</Form.Label>
                        <Form.Check
                            type="checkbox"
                            checked={note.isVendorVisible}
                            id="is-vendor-visible"
                            onChange={e => this.updateFields({ isVendorVisible: e.target.checked })}
                            label="Visible to vendor"
                        />
                        <Form.Check
                            type="checkbox"
                            checked={note.isPinned}
                            id="is-pinned"
                            onChange={e => this.updateFields({ isPinned: e.target.checked })}
                            label="Pinned (shows first)"
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Cancel
                    </button>
                    {note.id &&
                        <button type="button" className="btn btn-danger ms-auto me-auto" onClick={() => this.confirmDelete()}>
                            Delete
                        </button>
                    }
                    <button type="submit" className="btn btn-primary ms-auto">
                        Save
                    </button>
                </Modal.Footer>
            </form>
        );
    }
    
}

export default EditNoteModal;